import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { paymentAbstractPath } from 'utils/constants';
import { downloadFile, generatePreSignedUrl, paymentColor, titleCaseString } from 'utils/helpers';

const AccountantVerifyData = ({ abstractDetails }) => {
    const dispatch = useDispatch()
    const [coAuthorName, setCoAuthorName] = useState(true);

    const formattedAddress = [
        abstractDetails?.billing_address,
        abstractDetails?.billing_city,
        abstractDetails?.billing_state,
        abstractDetails?.billing_country,
    ]
        ?.filter(Boolean)
        ?.join(", ");

    return (
        <>
            <div className="row">
                <div className="col-lg-6 cmb-14">
                    <div className="text-14-400-17 color-new-car">
                        Reference No :
                    </div>
                    <span className="text-14-300-18 color-black-olive">
                        {abstractDetails?.reference_no ? abstractDetails?.reference_no : "-"}
                    </span>
                </div>

                <div className="col-lg-6 cmb-14">
                    <div className="text-14-400-17 color-new-car">
                        Payment Type :
                    </div>
                    <span className="text-14-300-18 color-black-olive">
                        {abstractDetails?.payment_type ? abstractDetails?.payment_type : "-"}
                    </span>
                </div>

                <div className="col-lg-6 cmb-14">
                    <div className="text-14-400-17 color-new-car">
                        Payment Category :
                    </div>
                    <span className="text-14-300-18 color-black-olive">
                        {abstractDetails?.payment_category
                            ? abstractDetails?.payment_category === "1"
                                ? "Abstract Paper"
                                : "Journal Publication"
                            : "-"}
                    </span>
                </div>

                <div className="col-lg-6 cmb-14">
                    <div className="text-14-400-17 color-new-car">
                        Payment Proof :
                    </div>
                    <span
                        className="text-14-300-18 color-new-car pointer"
                        onClick={async () => {
                            let downloadContent = await generatePreSignedUrl(
                                abstractDetails?.payment_proof,
                                paymentAbstractPath
                            );

                            dispatch(downloadFile(downloadContent));
                        }}
                    >
                        {abstractDetails?.payment_proof ? abstractDetails?.payment_proof : "-"}
                    </span>
                </div>

                <div className="col-lg-6 cmb-14">
                    <div className="text-14-400-17 color-new-car">
                        Total Amount :
                    </div>
                    <span className="text-14-300-18 color-black-olive">
                        {abstractDetails?.total_amount ? abstractDetails?.total_amount : "-"}
                    </span>
                </div>

                <div className="col-lg-6 cmb-14">
                    <div className="text-14-400-17 color-new-car">
                        Payment Status :
                    </div>

                    <span
                        className={paymentColor(
                            abstractDetails?.payment_status
                        )}
                    >
                        {abstractDetails?.payment_status
                            ? abstractDetails?.payment_status
                            : '-'}
                    </span>
                </div>

                <div className="col-lg-6 cmb-14">
                    <div className="text-14-400-17 color-new-car">
                        Author Name :
                    </div>
                    <span className="text-14-300-18 color-black-olive">
                        {abstractDetails?.author_name ? titleCaseString(abstractDetails?.author_name) : "-"}
                    </span>
                </div>
                <div className="col-lg-6 cmb-14">
                    <div className="text-14-400-17 color-new-car">
                        Verify By :
                    </div>
                    <span className="text-14-300-18 color-black-olive">
                        Accountant
                    </span>
                </div>
            </div>

            <div
                className={`cmb-18 my-4 br-5 ${coAuthorName ? 'b-0-7-5' : ''
                    }`}
            >
                <div className="bg-E9EE br-5 text-14-500-17 d-flex flex-column">
                    <div
                        className="cps-20 cpt-12 cpe-20 color-new-car cpb-12 d-flex align-items-center justify-content-between pointer flex-grow-1"
                        onClick={() => {
                            setCoAuthorName(!coAuthorName);
                        }}
                    >
                        <div>Co-Author Name</div>
                        <i
                            className={`${coAuthorName
                                ? 'bi bi-chevron-up'
                                : 'bi bi-chevron-down'
                                }`}
                            style={{ fontSize: '15px' }}
                        />
                    </div>
                    {coAuthorName &&
                        abstractDetails?.co_authors?.length > 0 && (
                            <div className="cp-15 bg-white br-5 iferp-scroll overflow-auto">
                                <ol className="co-author-name">
                                    {abstractDetails?.co_authors?.map(
                                        (author, index) => (
                                            <li key={author.id || index}>
                                                {author.name}
                                            </li>
                                        )
                                    )}
                                </ol>
                            </div>
                        )}
                </div>
            </div>


            <div className="w-50">
                <h2 className="text-16-400-20 color-new-car cmb-20">
                    Billing Address :
                </h2>
                <div className="d-flex align-items-center gap-2 cmb-18">
                    <i className="bi bi-geo-alt" />
                    <div className="text-14-300-24 color-black-olive">
                        {formattedAddress ? formattedAddress : "-"}
                    </div>
                </div>

                <div className="d-flex align-items-center gap-5 cmb-36">
                    <div className="d-flex align-items-center gap-2 cmb-18">
                        <i className="bi bi-geo" />
                        <div className="text-14-300-24 color-black-olive">
                            {abstractDetails?.billing_zip_code ? abstractDetails?.billing_zip_code : "-"}
                        </div>
                    </div>

                    <div className="d-flex align-items-center gap-2 cmb-18">
                        <i className="bi bi-globe-americas" />
                        <div className="text-14-300-24 color-black-olive">
                            {abstractDetails?.billing_country ? abstractDetails?.billing_country : "-"}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AccountantVerifyData
